import { semver } from './version.js'

export function releaseLabel(extension) {
  return semver(extension?.plugin?.published_semantic_version || extension?.latestPublishedVersion?.semantic_version) || '—'
}

export function installedLabel(extension) {
  if (!extension?.installation) return ''
  const version = semver(extension.installation.resolved_semantic_version)
  return version ? `Installed ${version}` : 'Installed'
}

export function draftLabel(extension) {
  const draft = extension?.draftVersion
  if (!draft || draft.status !== 'draft') return ''
  const version = semver(draft.semantic_version)
  return version ? `Draft ${version}` : 'Draft'
}

export function hasPublishedUpdate(extension) {
  if (!extension?.installation) return false
  const published = Number(extension?.plugin?.published_version || extension?.latestPublishedVersion?.version || 0)
  const installed = Number(extension.installation.resolved_version || 0)
  if (!published || !installed) return false
  // Published version is an authoritative catalog pointer, not a monotonic build counter.
  // Reopened drafts can publish a lower DB revision than an older immutable release.
  const publishedId = extension?.latestPublishedVersion?.id
  const installedId = extension.installation.resolved_version_id
  if (publishedId && installedId) return publishedId !== installedId
  return published !== installed
}
